import React from 'react';
import { ArrowLeft, Lock, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';
import { formatMoney } from '../../utils/formatMoney';

const MobilePaymentBar = ({
  total,
  canPay,
  allAgreed,
  isProcessing,
  onBack,
  onPay,
  paymentMethod = 'cash',
}) => {
  // Hide pay button for PayPal since payment is handled via PayPal SDK buttons
  const showPayButton = paymentMethod !== 'paypal';
  
  return (
    <div
      className="fixed bottom-0 left-0 right-0 bg-white border-t-2 border-[#FF8C00] p-4 lg:hidden z-50 shadow-lg"
      data-testid="mobile-payment-bar"
    >
      <div className="flex items-center justify-between gap-3">
        <Button
          variant="outline"
          size="sm"
          onClick={onBack}
          className="border-gray-300 text-gray-700 hover:bg-gray-100"
          disabled={isProcessing}
          data-testid="mobile-back-btn"
        >
          <ArrowLeft className="h-4 w-4" />
        </Button>

        <div className="flex-1 text-center">
          <p className="text-xs text-gray-500">Total</p>
          {/* ALWAYS 2 decimals */}
          <p className="text-xl font-bold text-black font-display">{formatMoney(total)}</p>
        </div>

        {showPayButton ? (
          <Button
            data-testid="mobile-pay-btn"
            className={`h-12 px-5 text-sm font-semibold transition-all ${
              canPay && allAgreed && !isProcessing
                ? 'bg-[#FF8C00] text-white hover:bg-[#E67E00]'
                : 'bg-gray-200 text-gray-400 cursor-not-allowed'
            }`}
            onClick={onPay}
            disabled={!canPay || !allAgreed || isProcessing}
          >
            {isProcessing ? (
              <Loader2 className="h-4 w-4 animate-spin" />
            ) : (
              <span className="flex items-center gap-1.5">
                <Lock className="h-4 w-4" />
                Pay
              </span>
            )}
          </Button>
        ) : (
          <span className="text-xs text-blue-600 max-w-[100px] text-center">
            Use PayPal button above ↑
          </span>
        )}
      </div>
    </div>
  );
};

export default MobilePaymentBar;
